/*
 * Copyright © 2017-2026 Knowledge for Decisions (K4D). All rights reserved.
 *
 * This code and associated materials are protected by copyright laws and international
 * treaties. Unauthorized use, reproduction, distribution, or modification of any content
 * from Knowledge for Decisions (K4D) is strictly prohibited. For inquiries regarding
 * the use or licensing of K4D's copyrighted materials, please contact us at
 * contact@k4d.com.br. "Knowledge for Decisions (K4D)" and the slogan "Using data to make
 * precise decisions" are registered trademarks of Knowledge for Decisions (K4D).
 */

/**
 * Event name for triggering login banner when consent is rejected.
 */
export const CDU_LOGIN_REQUIRED_EVENT = 'cdu:login-required';

/**
 * Event name for resuming login flow after consent is accepted from login banner.
 */
export const CDU_CONSENT_ACCEPTED_FOR_LOGIN_EVENT = 'cdu:consent-accepted-for-login';

/**
 * Dispatches an event to trigger the CDU consent banner for login.
 * This can be called from anywhere in the application, including non-React code.
 *
 * @returns {void}
 */
export function triggerLoginBannerEvent(): void {
  window.dispatchEvent(new CustomEvent(CDU_LOGIN_REQUIRED_EVENT));
}

/**
 * Dispatches an event to signal that consent was accepted from the login banner.
 * This triggers the login flow to automatically resume.
 *
 * @returns {void}
 */
export function triggerLoginResumeEvent(): void {
  window.dispatchEvent(new CustomEvent(CDU_CONSENT_ACCEPTED_FOR_LOGIN_EVENT));
}
